export enum AuthErrorMessage {
  INVALID_USER_OR_PASSWORD = 'This password is incorrect. Please try again.',
  NEW_USER = 'User does not have an account.',
  USER_ALMOST_LOCKED = 'You have one more attempt before your account is locked.',
  USER_LOCKED = `Due to an excessive number of unsuccessful attempts, we've locked your account for security. Check your email to unlock your account.`,
}
